import { downloadingCompanyExcel } from "@redux/Bookmark/bookmark.action";
import { profileName, profileType } from "@utils/enum";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";

export const FavouriteDownloadModal = ({ selectedCompanyArray, type, downloadModal, handleClose, clearSelection }) => {
  const dispatch = useDispatch();

  return (
    <div>
      <Modal size="md" centered show={downloadModal} onHide={handleClose}>
        <Modal.Header className="p-2">
          <div className="d-flex justify-content-between w-100 align-items-center">
            <div className="ml-2">
              <strong>Confirmation</strong>
            </div>
            <div>
              <Button
                className="btn btn-primary trademo-new-btn"
                onClick={() => {
                  dispatch(downloadingCompanyExcel({ selectedCompanyArray, type }));
                  handleClose();
                  clearSelection();
                }}>
                Confirm
              </Button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          You are downloading list of{" "}
          <strong>
            {selectedCompanyArray.length} Favourite {type === profileType.logistics ? "companies" : profileName[type]}
          </strong>{" "}
          which will cost you <strong>{selectedCompanyArray.length * 5} Download Credits</strong>.
        </Modal.Body>
      </Modal>
    </div>
  );
};
